import React from 'react'

import type {
  BlockType,
  BlockPayload,
  IBlockPayloadCountdown,
  IBlockPayloadBankAccounts,
  ISalepageFormProduct,
} from '../../types'
import { ImageBlock } from './blocks/ImageBlock'
import { VideoBlock } from './blocks/VideoBlock'
import { ContentBlock } from './blocks/ContentBlock'
import { SliderBlock } from './blocks/SliderBlock'
import { FormBlock } from './blocks/FormBlock'
import { CountdownBlock } from './blocks/CountdownBlock'
import { BankAccountsBlock } from './blocks/BankAccountsBlock'

interface BlockPayloadFormProps {
  block: { type: BlockType; payload: BlockPayload }
  onChange: (payload: BlockPayload) => void
}

export const BlockPayloadForm: React.FC<BlockPayloadFormProps> = ({
  block,
  onChange,
}) => {
  const { type, payload } = block

  switch (type) {
    case 'IMAGE':
      return (
        <ImageBlock
          payload={payload as { url?: string; alt?: string; caption?: string }}
          onChange={onChange}
        />
      )
    case 'VIDEO':
      return (
        <VideoBlock
          payload={payload as { url?: string; width?: string; height?: string; fullWidth?: boolean }}
          onChange={onChange}
        />
      )
    case 'CONTENT':
      return (
        <ContentBlock
          payload={payload as { html?: string }}
          onChange={onChange}
        />
      )
    case 'SLIDER':
      return (
        <SliderBlock
          payload={payload as { images?: Array<{ url: string; alt?: string }> }}
          onChange={onChange}
        />
      )
    case 'FORM':
      return (
        <FormBlock
          payload={payload as { products?: ISalepageFormProduct[]; btnText?: string }}
          onChange={onChange}
        />
      )
    case 'COUNTDOWN':
      return (
        <CountdownBlock
          payload={payload as IBlockPayloadCountdown}
          onChange={onChange}
        />
      )
    case 'BANK_ACCOUNTS':
      return (
        <BankAccountsBlock
          payload={(payload as IBlockPayloadBankAccounts) ?? { accounts: [] }}
          onChange={onChange}
        />
      )
    default:
      return null
  }
}
